import { z } from "zod";

export const DeploymentVendorItemSchema = z.object({
  Id: z.number(),
  Name: z.string(),
});

export type DeploymentVendorItemType = z.infer<
  typeof DeploymentVendorItemSchema
>;
